import React, { useState } from 'react'
import { Post } from '../../web_api/api'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'

export default function BannerCreate() {
    const [image, setImage] = useState('')
    const [imageArr, setImageArr] = useState([])
    const [imageTempArr, setImageTempArr] = useState([])
    const [showSave, setShowSave] = useState(false)
    const [showNextImage, setShowNextImage] = useState(false)
    const [showImgText, setShowImgText] = useState(false)


    const ImageAddSection = (e) => {

        setImageArr([
            ...imageArr,
            {}
        ])
        // console.log(proMedName, 'pro med')
        setShowNextImage(true)
        setShowSave(false)
    } // to add next section for image

    const ImageSaveSection = (e) => {
        setImage(e.target.files[0])

        setShowImgText(true)

    } // to save image from onChange

    const handleSaveImage = () => {
        setImageTempArr([...imageTempArr, image])
        setShowSave(true)
    } // to create saved for final image arr

    const create = async () => {
        const formData = new FormData()
        imageTempArr.map((item) => (
            formData.append('banners', item)
        ))

        if (imageTempArr.length === 0) {
            Swal.fire({
                title: 'Need Image!',
                text: 'Try again!',
                icon: 'error',
                // showCancelButton: true,

                showConfirmButton: false,
                timer: 2000
            })
        } else {
            await Post('/banner-photos', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

        }

    }

    return (
        <div>

            <div className='border-1 border-info rounded-1 border p-3 mt-2'>
                <div className=''>
                    <label for='#tn' className={(!imageTempArr) ? 'text-red' : ''}>Image <span className='text-red'>*</span></label>
                    <input type='file' id='tn' className='form-control' onChange={(e) => ImageSaveSection(e)} />
                </div>
                {showNextImage && (
                    <>
                        {imageArr.map((item, index) => (
                            <div className=''>
                                <label for='#tn' className={(!imageTempArr) ? 'text-red' : ''}>Image <span className='text-red'>*</span></label>
                                <input type='file' id='tn' className='form-control' onChange={(e) => ImageSaveSection(e)} />
                            </div>
                        ))}


                    </>

                )}

                <div className='mt-3 text-end'>
                    <button className='btn btn-sm btn-success rounded-2' onClick={handleSaveImage} >Save</button>
                    &nbsp;
                    {!showSave ? (
                        <button className='btn btn-sm btn-default rounded-2'  >Add</button>
                    ) : (
                        <button className='btn btn-sm btn-primary rounded-2' onClick={ImageAddSection} >Add</button>
                    )}

                </div>
            </div>
            {/* Footer Button */}
            <div className='mt-3 text-start '>
                <Link to='/treatment-dashboard' className='btn btn-sm btn-default text-red rounded-2  ' >Cancel</Link>
                <button className='btn btn-sm btn-success rounded-2 ml-2 ' onClick={create}>Create</button>
            </div>
        </div>
    )
}
